import styled from 'styled-components';

export const StyledQuoteList = styled.div`
  display: flex;
  flex-direction: column;
`;